import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TarefasService } from 'src/app/tarefas/service/tarefas.service';
import { CommonLoaderComponent } from '../../common-loader/common-loader.component';
import { ModalMensagemComponent } from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';
import { FiltroSelectBuscaComponent } from 'src/app/shared/components/filtro-select-busca/filtro-select-busca.component';
import { FiltroSelectOption } from 'src/app/shared/components/filtro-select/filtro-select.component';

@Component({
  selector: 'app-editar-tarefa-criada',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonLoaderComponent,
    ModalMensagemComponent,
    FiltroSelectBuscaComponent,
  ],
  templateUrl: './editar-tarefa-criada.component.html',
  styleUrls: ['./editar-tarefa-criada.component.scss'],
})
export class EditarTarefaCriadaComponent implements OnInit, OnChanges {
  today: string = new Date().toISOString().split('T')[0];
  carregando: boolean = false;
  @Input() tarefa: any;
  @Input() tarefaSelecionada: any;
  @Output() close = new EventEmitter<void>();
  @Output() fecharDialogo = new EventEmitter<void>();
  @Output() tarefaEditada = new EventEmitter<any>();
  @Output() loading = new EventEmitter<boolean>();
  @Input() obras: { workID: number; workName: string; isSelected?: boolean }[] =
    [];

  description: string = '';
  data: string = '';
  hora: string = '';
  responsibleID: number | string = '';
  actionID: string = '';
  workID: number;
  responsavel: any[] = [];
  tarefas: any[] = [];
  sucesso = false;
  campoObrigatorioErro = false;
  opcoesObras: FiltroSelectOption[] = [];
  opcoesResponsaveis: FiltroSelectOption[] = [];
  private resultadoEdicao: any = null;

  constructor(
    private readonly _tarefaService: TarefasService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.carregando = true;
    let obrasLoaded = false;
    let responsaveisLoaded = false;
    let acoesLoaded = false;
    const checkLoaded = () => {
      if (obrasLoaded && responsaveisLoaded && acoesLoaded) {
        this.carregando = false;
        if (this.tarefaSelecionada) {
          this.preencherCampos(this.tarefaSelecionada);
        }
        this.cdr.detectChanges();
      }
    };

    this._tarefaService.listResponsables().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        this.opcoesResponsaveis = this.responsavel.map((r) => ({ value: r.id, label: r.name }));
        responsaveisLoaded = true;
        checkLoaded();
      },
      (error) => {
        console.error('Erro ao buscar responsáveis:', error);
        responsaveisLoaded = true;
        checkLoaded();
      }
    );

    this._tarefaService.listActions().subscribe(
      (response) => {
        this.tarefas = response.data.sort((a, b) =>
          a.description.localeCompare(b.description)
        );
        acoesLoaded = true;
        checkLoaded();
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
        acoesLoaded = true;
        checkLoaded();
      }
    );
  }

  compareWork(a: any, b: any): boolean {
    return Number(a) === Number(b);
  }

  preencherCampos(tarefa: any): void {
    this.description = tarefa.description || '';
    this.responsibleID = tarefa.responsibleID?.toString() || '';
    this.actionID = tarefa.actionID?.toString() || '';

    const workIDNumber = Number(tarefa.workID);
    if (!isNaN(workIDNumber)) {
      this.workID = workIDNumber;
      this.obras = this.obras.map((obra) => ({
        ...obra,
        isSelected: obra.workID === workIDNumber,
      }));
    } else {
      console.warn(
        '[EditarTarefaCriadaComponent] workID recebido não é um número válido:',
        tarefa.workID
      );
      this.workID = 0;
    }

    if (tarefa.followUpDate) {
      const [date, time] = tarefa.followUpDate.split('T');
      this.data = date || '';
      this.hora = time?.slice(0, 5) || '';
    }
  }

  ngOnChanges(): void {
    if (this.tarefaSelecionada) {

      this.listarObras();
      if (this.obras.length > 0) {
        this.preencherCampos(this.tarefaSelecionada);
        this.cdr.detectChanges();
      }
    }
  }

  popularResponsavelObra(): void {
    this._tarefaService.listResponsables().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      },
      (error) => {
        console.error('Erro ao buscar responsáveis:', error);
      }
    );
  }

  popularAcao(): void {
    this._tarefaService.listActions().subscribe(
      (response) => {
        this.tarefas = response.data.sort((a, b) =>
          a.description.localeCompare(b.description)
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      }
    );
  }

  editarTarefa() {
    this.campoObrigatorioErro = false;
    if (!this.responsibleID || !this.actionID || !this.workID) {
      this.campoObrigatorioErro = true;
      console.error('Erro: Campos obrigatórios não preenchidos');
      return;
    }

    const tarefaId =
      this.tarefaSelecionada?.id ?? this.tarefaSelecionada?.taskID;

    const body = {
      actionID: Number(this.actionID),
      followUp: this.formatFollowUp(this.data, this.hora),
      responsibleID: Number(this.responsibleID),
      description: this.description,
      workID: this.workID,
    };

    this.carregando = true;
    this._tarefaService.editTasks(tarefaId, body).subscribe({
      next: (res) => {
        this.resultadoEdicao = res;
        this.sucesso = true;
        this.carregando = false;
      },
      error: (err) => {
        console.error('Erro ao editar tarefa:', err);
        this.carregando = false;
      },
    });
  }

  formatFollowUp(date: string, time: string): string {
    if (!date || !time) return '';
    const [yyyy, mm, dd] = date.split('-');
    let horaFormatada = time.length === 5 ? `${time}:00` : time;
    return `${dd}/${mm}/${yyyy} ${horaFormatada}`;
  }

  fecharSucesso() {
    this.sucesso = false;
    this.tarefaEditada.emit(this.resultadoEdicao);
    this.fecharDialogo.emit();
  }

  limparCampos(): void {
    this.description = '';
    this.responsibleID = '';
    this.actionID = '';
    this.data = '';
    this.hora = '';
  }
  fecharModal() {
    this.fecharDialogo.emit();
  }

  listarObras(): void {
    const tarefaId =
      this.tarefaSelecionada?.id ?? this.tarefaSelecionada?.taskID;
    this.carregando = true;
    this._tarefaService.listWorksEdit(tarefaId).subscribe(
      (response) => {
        const workIDNumber = Number(this.tarefaSelecionada?.workID);
        this.obras = response.data.map((obra: any) => ({
          ...obra,
          isSelected: obra.workID === workIDNumber,
        }));
        this.opcoesObras = this.obras.map((obra) => ({ value: obra.workID, label: obra.workName }));

        const obraSelecionada = this.obras.find((o) => o.isSelected);
        if (obraSelecionada) {
          this.workID = obraSelecionada.workID;
        }
   
        this.preencherCampos(this.tarefaSelecionada);
        this.carregando = false;
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
        this.carregando = false;
      }
    );
  }
}
